import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGuam = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_474)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M5.23657 21.913C7.16238 23.2295 9.49113 24 12 24C14.5089 24 16.8376 23.2295 18.7635 21.913L12 20.8695L5.23657 21.913Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.7635 2.08697C16.8376 0.770484 14.5089 0 12 0C9.49113 0 7.16238 0.770484 5.23657 2.08697L12 3.13045L18.7635 2.08697Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24 12C24 8.02922 21.6227 4.04156 18.7635 2.08697H5.23655C2.07516 4.24809 0 7.88156 0 12C0 16.1186 2.07516 19.7519 5.23655 21.913H18.7635C21.9249 19.7519 24 16.1186 24 12Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.3209 19.5749C11.1569 19.4342 7.30432 16.0851 7.30432 12C7.30432 7.91489 11.1569 4.56572 11.3209 4.42514L12 3.84305L12.6791 4.42509C12.843 4.56572 16.6956 7.91485 16.6956 12C16.6956 16.0852 12.8431 19.4343 12.6791 19.5749L12 20.157L11.3209 19.5749Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.6522 12C15.6522 8.34783 12 5.21737 12 5.21737C12 5.21737 8.34784 8.34792 8.34784 12C8.34784 13.1173 8.68989 14.1855 9.16435 15.1305H14.8357C15.3101 14.1855 15.6522 13.1173 15.6522 12Z",
				fill: "#338AF3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.6522 12C15.6522 13.1173 15.3101 14.1855 14.8357 15.1305L12 15.6522L9.16435 15.1305C8.68989 14.1855 8.34784 13.1173 8.34784 12H15.6522Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 18.7826C12 18.7826 13.7591 17.2743 14.8357 15.1305H9.16437C10.2409 17.2743 12 18.7826 12 18.7826Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.65216 9.91303H14.3478L12 12.2609L9.65216 9.91303Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.2173 11.4783H12.7825V16.1739H11.2173V11.4783Z",
				fill: "#A2001D"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_474",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgGuam;
